// extracted by mini-css-extract-plugin
export default {"Content":"DashboardPage_Content__gxmnj","Button":"DashboardPage_Button__Lugf7","Card":"DashboardPage_Card__VymI-"};